import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";
import { EditKontakDarurat } from "../../../../models/KontakDarurat";
import { allKontakDaruratKey } from "./useFetchKontakDarurat";

export async function editKontakDarurat(data: EditKontakDarurat) {
    const res = await ApiClient.put(`/EditEmergencyContact`, data);
    return res.data;
}

export const useEditKontakDarurat = mutationWrapper(editKontakDarurat, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakDaruratKey);
    },
});
